import { createContext } from 'react';

const EventFiltersContext = createContext({
    eventFilters: {},
    setEventFilters: () => {},
});

export default EventFiltersContext;
